import { Button } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import Table from "../../../../components/Table";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import InputFactory from "../../../../components/InputFactory";
import AllowanceAssignTablePresenter from "./AllowanceAssignTablePresenter";
import { v4 as uuidv4 } from "uuid";

export default class ContributionAssignTable extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AllowanceAssignTablePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      object: [],
      contribution: [],
      selectedContribution: "",
      amount: "",
      startDate: "",
      objectID: "",
      contribution_method: "",
      fix: "",
      formula: "",
      error: false,
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const contribution = await findObjectUseCase().execute(
      "contribution_type",
      { where: { status: "active" } }
    );
    // const object =
    //   JSON.parse(sessionStorage.getItem("contributionObject")) || [];
    this.setState({ contribution });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      this.props.contributionData(this.state.object);
    }
  }

  getCollectionName() {
    return "contributions";
  }

  async handleDeleteData(data) {
    this.setState((prevState) => {
      prevState.object.filter((item) => item.id !== data.id);
    });
  }

  async handleObjectData(data) {
    const date = new Date(data.startdate);
    const formattedDate = date.toISOString().slice(0, 10);
    const { contribution_method } =
      (
        await findObjectUseCase().execute("contribution_type", {
          where: { status: "active" },
        })
      ).find(
        ({ contributionType }) => contributionType === data.contribution
      ) || {};
    this.setState({
      objectID: data.id,
      selectedContribution: data.contribution,
      amount: data.amount,
      startDate: formattedDate,
      contribution_method,
    });
  }

  async refetchData() {
    this.setState({
      objectID: "",
      selectedContribution: "",
      amount: "",
      startDate: "",
    });
  }

  async handleAllowanceChange(selectedContribution) {
    const contributionType = await findObjectUseCase().execute(
      "contribution_type",
      { where: { status: "active" } }
    );
    const filterContribution = contributionType.filter(
      (data) => data.contributionType === selectedContribution
    );
    const contribution_methods = filterContribution.map(
      (data) => data.contribution_method
    );
    const fix = filterContribution.map((data) => data.fix);
    const formula = filterContribution.map((data) => data.formula);
    const contribution_method = contribution_methods.join(", ");
    this.setState({ selectedContribution, contribution_method, fix, formula });
  }

  handleAmountChange(amount) {
    this.setState({ amount: amount.toString() });
  }
  handleStartDate(startDate) {
    this.setState({ startDate });
  }

  objectData(amount, employeeEmail, empID) {
    const id = uuidv4();
    const data = {
      id,
      // employeeEmail,
      // empID,
      contribution: this.state.selectedContribution,
      amount: amount,
      startdate: this.state.startDate,
    };

    this.setState((prevState) => {
      const dataExists = prevState.object.some(
        (item) => item.contribution === data.contribution
      );
      if (!dataExists) {
        this.setState({ error: false });
        return { object: [...prevState.object, data] };
      } else {
        this.setState({ error: true });
      }
    });
    this.refetchData();
    this.refetchData();
  }
  handleSaveClick() {
    // let employeeEmail = [];
    // let empID = [];

    // this.props.selected.forEach((data) => {
    //   employeeEmail.push(data.email);
    //   empID.push(data.id);
    // });

    if (this.state.objectID !== "") {
      const data = {
        // employeeEmail,
        // empID,
        contribution: this.state.selectedContribution,
        amount: this.state.amount,
        startdate: this.state.startDate,
        id: this.state.objectID,
      };

      this.setState((prevState) => ({
        object: prevState.object.map((item) =>
          item.id === prevState.objectID ? data : item
        ),
      }));

      this.refetchData();
      this.refetchData();
    } else {
      if (this.state.contribution_method === "INPUT AMOUNT") {
        this.objectData(this.state.amount);
      } else if (this.state.contribution_method === "FIX AMOUNT") {
        this.objectData(this.state.fix.join(", "));
      } else if (this.state.contribution_method === "FORMULA") {
        this.objectData(this.state.formula.join(", "));
      }
    }
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      object,
      contribution,
      selectedContribution,
      contribution_method,
      current,
      limit,
      count,
    } = this.state;

    // if (object.length > 0) {
    //   sessionStorage.setItem("contributionObject", JSON.stringify(object));
    // }

    let isDisable = false;
    if (
      contribution_method === "INPUT AMOUNT" &&
      (!this.state.amount || !this.state.startDate)
    ) {
      isDisable = true;
    } else if (
      (contribution_method === "FIX AMOUNT" ||
        contribution_method === "FORMULA") &&
      !this.state.startDate
    ) {
      isDisable = true;
    }
    return (
      <>
        <div className="m-4">
          <div className="row">
            <div className="col-lg-2 mb-4">
              <SearchSelect
                value={selectedContribution}
                onChange={this.handleAllowanceChange.bind(this)}
                options={contribution.map((contribution) => ({
                  label: contribution.contributionType,
                  value: contribution.contributionType,
                }))}
              />
            </div>
            {contribution_method === "INPUT AMOUNT" && (
              <div className="col-lg-2 mb-4">
                <InputFactory
                  type="DecemalNum"
                  value={this.state.amount}
                  placeholder="Contribution Amount"
                  field="amount"
                  onChange={this.handleAmountChange.bind(this)}
                />
              </div>
            )}
            <div className="col-lg-2 mb-4">
              <InputFactory
                value={this.state.startDate}
                placeholder="start Date"
                type="Date"
                field="startdate"
                onChange={this.handleStartDate.bind(this)}
              />
            </div>
            <div className="col-lg-2 mb-4">
              <Button
                className="btn btn-primary"
                onClick={this.handleSaveClick.bind(this)}
                disabled={isDisable || !this.state.selectedContribution}
              >
                Save
              </Button>
            </div>

            <div className="col-lg-4 mb-4">
              <p
                className="fs-6 fw-bold text-danger text-center"
                style={{ display: !this.state.error ? "none" : "block" }}
              >
                You cannot add same contribution.
              </p>
            </div>
          </div>
          <Table
            objectId={this.handleDeleteData.bind(this)}
            refetch={this.refetchData.bind(this)}
            objectData={this.handleObjectData.bind(this)}
            fields={schema.fields}
            objects={object}
            collection={schema}
            count={count}
            limit={limit}
            current={current}
            loadPagination={this.onClickPagination.bind(this)}
            actionsList={[
              {
                label: <i className="bi bi-pencil-square" />,
                actionType: "object",
              },
              {
                label: <i className="bi bi-trash" />,
                actionType: "delete",
              },
            ]}
            excludeFields={Object.keys(schema.fields).reduce(
              (acc, key) => {
                const options = schema.fields[key];
                if (options.read === false) {
                  acc.push(key);
                }
                switch (options._type || options.type) {
                  case "Relation":
                  case "Array":
                  case "Object":
                  case "File":
                    acc.push(key);
                    break;
                  default:
                }
                return acc;
              },
              ["id", "Created At", "Updated At"]
            )}
            onClickItem={this.onClickItem.bind(this)}
          />
        </div>
      </>
    );
  }
}
